export const borderColor = "rgb(240, 240, 240)";
